//const { $, boostPopupOptions } = window
//const { $ } = window
//const $body = $(document.body)

export default {
	init() {

    },
    finalize() {
        
    },
}